import { Schema, arrayOf, normalize } from 'normalizr'
import { camelizeKeys } from 'humps'
import 'isomorphic-fetch'
// import { oauthParams } from 'Oauth'

// let API_ROOT = (process.env.NODE_ENV === 'production') 
//   ? 'https://core-api.sonnenbatterie.de/'
//   : 'http://localhost:3000/'
let API_ROOT = 'https://core-api.sonnenbatterie.de/sonnen_community/'

// 'https://realdaten.sonnenbatterie.de/'

// Fetches an API response and normalizes the result JSON according to schema.
// This makes every API response have the same shape, regardless of how nested it was.
function callApi(endpoint, schema) {
  const fullUrl = ((endpoint.indexOf(API_ROOT) === -1) ? API_ROOT + endpoint : endpoint)

  return fetch(fullUrl, {
      headers: {
        'Accept': 'application/vnd.sonnenbatterie.api.core.v3+json'
      }
    })
    .then(response =>
      response.json().then(json => ({ json, response }))
    )
    .then(({ json, response }) => {
      
      // quickfix to remove root element
      if (json.result && typeof json.result !== 'undefined') {
        json = json.result
      } else if (json.results && typeof json.results !== 'undefined') {
        // global workaround (because meta paging is not stored)
        // todo: replace api middleware with axios
        window['api__'+schema._itemSchema._key+'CurrentPage'] = json.current_page
        window['api__'+schema._itemSchema._key+'TotalPages'] = json.total_pages
        json = json.results
      } else if (json.status == 'ZERO_RESULTS') {
        json = []
      }
      // console.log(json.length)
      
      if ( ! response.ok) {
        return Promise.reject(json)
      }

      const camelizedJson = camelizeKeys(json)
      
      return Object.assign({},
        normalize(camelizedJson, schema)
      )
    })
}

// We use this Normalizr schemas to transform API responses from a nested form
// to a flat form where repos and users are placed in `entities`, and nested
// JSON objects are replaced with their IDs. This is very convenient for
// consumption by reducers, because we can easily build a normalized tree
// and keep it updated as we fetch more data.

// Read more about Normalizr: https://github.com/gaearon/normalizr

const energyMapSchema = new Schema('energy_maps', {
  idAttribute: 'id'
})
const placesSchema = new Schema('places', {
  idAttribute: 'id'
})
const batteriesSchema = new Schema('batteries', {
  idAttribute: 'id'
})
const videosSchema = new Schema('videos', {
  idAttribute: 'id'
})
const ambassadorsSchema = new Schema('ambassadors', {
  idAttribute: 'id'
})
const awardsSchema = new Schema('awards', {
  idAttribute: 'id'
})

// Schemas for Github API responses.
export const Schemas = {
  ENERGY_MAP: energyMapSchema,
  ENERGY_MAP_ARRAY: arrayOf(energyMapSchema),
  PLACE: placesSchema,
  PLACE_ARRAY: arrayOf(placesSchema),
  BATTERY: batteriesSchema,
  BATTERY_ARRAY: arrayOf(batteriesSchema),
  VIDEO: videosSchema,
  VIDEO_ARRAY: arrayOf(videosSchema),
  AMBASSADOR: ambassadorsSchema,
  AMBASSADOR_ARRAY: arrayOf(ambassadorsSchema),
  AWARD: awardsSchema,
  AWARD_ARRAY: arrayOf(awardsSchema),
}

// Action key that carries API call info interpreted by this Redux middleware.
export const CALL_API = Symbol('Call API')

// A Redux middleware that interprets actions with CALL_API info specified.
// Performs the call and promises when such actions are dispatched.
export default store => next => action => {
  const callAPI = action[CALL_API]
  if (typeof callAPI === 'undefined') {
    return next(action)
  }

  let { endpoint } = callAPI
  const { schema, types } = callAPI

  if (typeof endpoint === 'function') {
    endpoint = endpoint(store.getState())
  }

  if (typeof endpoint !== 'string') {
    throw new Error('Specify a string endpoint URL.')
  }
  if (!schema) {
    throw new Error('Specify one of the exported Schemas.')
  }
  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected an array of three action types.')
  }
  if (!types.every(type => typeof type === 'string')) {
    throw new Error('Expected action types to be strings.')
  }

  function actionWith(data) {
    const finalAction = Object.assign({}, action, data)
    delete finalAction[CALL_API]
    return finalAction
  }

  const [ requestType, successType, failureType ] = types
  next(actionWith({ type: requestType }))

  return callApi(endpoint, schema).then(
    response => next(actionWith({
      response,
      type: successType,
      isFetching: false
    })),
    error => next(actionWith({
      type: failureType,
      error: error.message || 'Something bad happened',
      isFetching: false
    }))
  )
}


// WEBPACK FOOTER //
// ./src/middleware/api.js